const SITE_URL = 'https://funerariacoquimbo.cl';
const DEFAULT_SOCIAL_IMAGE = `${SITE_URL}/android-chrome-512x512.png`;

function upsertMeta(attribute, value, content) {
  let element = document.head.querySelector(`meta[${attribute}="${value}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, value);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
}

function upsertCanonical(url) {
  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }

  element.setAttribute('href', url);
}

export function setPageMetadata({ title, description, path, image = DEFAULT_SOCIAL_IMAGE }) {
  const canonicalUrl = `${SITE_URL}${path === '/' ? '/' : path.replace(/\/$/, '')}`;

  document.title = title;
  upsertMeta('name', 'description', description);
  upsertCanonical(canonicalUrl);

  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:locale', 'es_CL');
  upsertMeta('property', 'og:title', title);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:url', canonicalUrl);
  upsertMeta('property', 'og:image', image);

  upsertMeta('name', 'twitter:card', 'summary');
  upsertMeta('name', 'twitter:title', title);
  upsertMeta('name', 'twitter:description', description);
  upsertMeta('name', 'twitter:image', image);
}
